import { SettingConst } from "@faire/web-api--source/types";
import { IFrontendSetting } from "@faire/web/common/settings/declarations/IFrontendSetting";
import { useEffect } from "react";

import { useAssignSetting } from "./__internal__/useSetting";

export function useAssignEffect(
  setting: SettingConst | IFrontendSetting,
  condition: boolean
) {
  const assign = useAssignSetting(setting);
  useEffect(() => {
    if (condition) {
      assign();
    }
  }, [assign, condition]);
}
